// sidebar
import { Link } from 'react-router-dom';
import { route } from '/@/app/routes';
import { useNavigate } from 'react-router-dom';
import { Container, List, ListItem, ListItemButton, ListItemText } from '@mui/material';

export const TesterViewMenu = ({drawerOpen, setDrawerOpen}) => {
    const navigate = useNavigate();
    const onItemClick = () => {
        setDrawerOpen(false);
    }
    return (
        <Container maxWidth="md" sx={{ paddingTop: "20px" }}>
            <List>
                <ListItem disablePadding>
                    <ListItemButton onClick={onItemClick} component={Link} to={route("/tester/style/")}>
                        <ListItemText primary="Общий стиль приложения" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={onItemClick} component={Link} to={route("/tester/actions/")}>
                        <ListItemText primary="Отладочные действия" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton>
                        <ListItemText primary="Тест кейсы динамики" />
                    </ListItemButton>
                </ListItem>
                <List sx={{ pl: 4 }}>
                    <ListItemButton onClick={onItemClick} component={Link} to={route("/tester/dynamics/cases/main/")}>
                        <ListItemText primary="Главные кейсы" />
                    </ListItemButton>
                    <ListItemButton onClick={onItemClick} component={Link} to={route("/tester/dynamics/cases/typical/")}>
                        <ListItemText primary="Типичные кейсы пользователей" />
                    </ListItemButton>
                    <ListItemButton onClick={onItemClick} to={route("/tester/dynamics/cases/biohacker01/")}>
                        <ListItemText primary="Биохакер 01" />
                    </ListItemButton>
                    <ListItemButton onClick={onItemClick} to={route("/tester/dynamics/cases/biohacker02/")}>
                        <ListItemText primary="Биохакер 02" />
                    </ListItemButton>
                    <ListItemButton onClick={onItemClick} to={route("/tester/dynamics/cases/biohacker03/")}>
                        <ListItemText primary="Биохакер 03" />
                    </ListItemButton>
                </List>
            </List>
        </Container>
    )
}
